// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State, ViewCreatorTourSteps } from '../../types.tsx';

export const setViewCreatorSpotlightTourStep =
	(step: ViewCreatorTourSteps | null): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			...state,
			viewCreator: {
				...state.viewCreator,
				tourSpotlightStep: step,
			},
		});
	};

export const setViewCreatorSpotlightDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			...state,
			viewCreator: {
				...state.viewCreator,
				tourDismissed: true,
			},
		});
	};
